import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-stone-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-white font-bold text-lg mb-4">
              <a href="/" className="hover:text-orange-400 transition-colors">在线撸</a>
            </h4>
            <p className="text-sm text-stone-400 leading-relaxed">
              随时随地在线撸的极致体验平台。汇聚视频、撸猫、撸串、撸铁、撸代码、撸题六大内容板块，为你带来轻松有趣的线上休闲体验。
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">
              <a href="#categories" className="hover:text-orange-400 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2 text-sm">
              {[
                { to: '/category/video', label: '在线撸视频' },
                { to: '/category/cat', label: '在线撸猫' },
                { to: '/category/bbq', label: '在线撸串' },
                { to: '/category/fitness', label: '在线撸铁' },
                { to: '/category/code', label: '在线撸代码' },
                { to: '/category/exam', label: '在线撸题' },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="hover:text-orange-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">
              <a href="/about" className="hover:text-orange-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-orange-400 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="hover:text-orange-400 transition-colors">用户口碑</Link></li>
              <li><Link to="/about" className="hover:text-orange-400 transition-colors">联系我们</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">关注我们</h4>
            <p className="text-sm text-stone-400 mb-3">随时随地，在线撸起来！</p>
            <div className="flex space-x-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-700 hover:bg-orange-600 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-700 hover:bg-orange-600 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-700 hover:bg-orange-600 transition-colors" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-stone-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between text-xs text-stone-500">
          <p>&copy; 2026 在线撸 — 随时随地在线撸的极致体验平台. All rights reserved.</p>
          <div className="flex space-x-4 mt-2 sm:mt-0">
            <a href="#" className="hover:text-stone-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-stone-300 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}